import React, { Suspense } from "react";
import { versions } from "../../util/constants";
import { getVersion } from "../../util/getVersion";
import { getIsEmbedded } from "../../util/params";
import LoadingScreen from "../LoadingScreen";

const ImageChoiceScreen = React.lazy(() =>
  import("../ImageChoiceScreen/ImageChoiceScreen")
);

const DemoScreen = React.lazy(() => import("../DemoScreen/DemoScreen"));

const version = getVersion();
export function InitialScreen() {
  const isEmbedded = getIsEmbedded();
  return isEmbedded ? (
    <LoadingScreen />
  ) : (
    <Suspense fallback={<LoadingScreen />}>
      {
        {
          [versions.spin]: <DemoScreen />,
          [versions.image]: <ImageChoiceScreen />,
        }[version]
      }
    </Suspense>
  );
}
